<template>
  <BaseCard type="filled" class="relative flex w-full flex-col p-4">
    <h3 class="text-headline-small">{{ feedbackGoal.feedbackTopic.title }}</h3>
    <div class="mt-4 flex w-full flex-row gap-0.5">
      <div
        v-for="perspective in perspectives"
        :key="perspective.perspectiveKey"
        class="flex grow basis-0 flex-row items-center"
      >
        <BaseProgressRing
          :radius="26"
          :thickness="20"
          :percentage="perspective.percentage"
          :icon="iconFor(perspective.perspectiveKey)"
          :color="perspective.color"
        />
        <div class="ml-2 flex flex-col">
          <span class="text-title-medium font-medium"
            >{{ perspective.done }}/{{ perspective.goal }}</span
          >
          <span class="text-body-small text-on-surface-variant">{{
            labelFor(perspective.perspectiveKey)
          }}</span>
        </div>
      </div>
    </div>
  </BaseCard>
</template>
<script lang="ts" setup>
  import BaseCard from '../../../core/components/base/card/BaseCard.vue'
  import BaseProgressRing from '../../../core/components/base/progress-ring/BaseProgressRing.vue'
  import { iconForPerspective } from '../../../core/models/feedback-perspective'
  import { findPerspective, resolvePerspectiveLabel } from '@/core/models/perspective-label'
  import {
    useFeedbackGoalProgress,
    type CoacheeFeedbackGoalData,
  } from '@/modules/coachees/composables/use-coachee-feedback-goal-progress'
  import { useI18n } from 'vue-i18n'
  import { storeToRefs } from 'pinia'
  import { useFeedbackTopicStore } from '@/stores/feedback-topic.store.ts'
  import { computed } from 'vue'

  interface Props {
    feedbackGoal: CoacheeFeedbackGoalData
  }

  const { feedbackGoal } = defineProps<Props>()
  const { perspectives } = useFeedbackGoalProgress(() => feedbackGoal.progress)
  const { t } = useI18n()

  const { templates } = storeToRefs(useFeedbackTopicStore())

  const topicPerspectives = computed(
    () =>
      templates.value.find((template) => template.id === feedbackGoal.feedbackTopic.id)
        ?.perspectives,
  )

  const iconFor = (key: string) =>
    iconForPerspective(findPerspective(key, topicPerspectives.value) ?? key)

  const labelFor = (key: string) =>
    resolvePerspectiveLabel(key, topicPerspectives.value, {
      selfLabel: t('perspectives.self.default'),
    })
</script>
